import gql from "graphql-tag";

const LiveEventUniversityFragment = gql`
    fragment UniversityFragment on UniversityField {
        id
        name
        slug
        logo
        squareLogo
        colour
        widgetUrl
        country {
            id
            name
            code
        }
    }
`;

export default LiveEventUniversityFragment;
